import Vue from 'vue';
import signalR from 'signalr';

Vue.prototype.$signalR = signalR;